/**
 * Every sport. The app opens here, because it always makes sense whatever
 * somebody came to do.
 *
 * The Next version awaited `loadSportRows()` and rendered once. `loadSportRows`
 * itself is untouched — it only calls the API client, which now works from the
 * browser — so the only difference is that the wait is visible.
 */

import { NewSport } from "@/components/NewSport";
import { PageHead, Problem } from "@/components/kit";
import { SportsTable } from "@/components/SportsTable";
import { loadSportRows } from "@/lib/sportRows";
import { useApi } from "@/spa/useApi";

export function SportsPage() {
  const { data, loading, error } = useApi(loadSportRows, [], "failed to load sports");

  if (error) return <Problem>Could not reach the admin service: {error}</Problem>;

  const rows = data ?? [];
  return (
    <>
      <PageHead
        title="Sports"
        note={
          loading && data === undefined
            ? "Loading…"
            : `${rows.length} sport${rows.length === 1 ? "" : "s"} — what each keeps, and how it is organised`
        }
        actions={<NewSport />}
      />
      {data !== undefined && <SportsTable rows={rows} />}
    </>
  );
}
